import { createSelector } from 'reselect';
import _ from 'lodash';
import { getAllParent, getAllChild } from 'utils/commonFunc';

const loginPointer = state => state.login;
const userPointer = state => state.dictionary.user;
const userDependencyPointer = state => state.dictionary.userDependency;

export default createSelector([loginPointer, userPointer, userDependencyPointer], (login, users, userDependency) => {
  const access = login.access.ownerEditAdvanced;
  let linkUser = [];
  if (access) {
    const { linkUserAny, linkUserParent, roleUser, logic } = access;
    if (linkUserAny && linkUserParent) {
      linkUser.push(login.id);
      if (linkUserAny === 1) {
        linkUser = _.union(linkUser, getAllChild(userDependency, login.id));
      }
      if (linkUserAny === 2) {
        linkUser = _.union(
          linkUser,
          userDependency.filter(x => x.parentId === login.id).map(w => w.userId),
        );
      }
      if (linkUserParent === 1) {
        linkUser = _.union(linkUser, getAllParent(userDependency, login.id));
      }
      if (linkUserParent === 2) {
        linkUser = _.union(
          linkUser,
          userDependency.filter(x => x.userId === login.id).map(w => w.parentId),
        );
      }
    }
    if (roleUser && roleUser.length > 0) {
      const userRoles = users.filter(x => roleUser.indexOf(x.roleId) >= 0).map(w => w.id);
      if (logic || (linkUserAny === null && linkUserParent === null)) {
        linkUser = _.union(linkUser, userRoles);
      } else {
        linkUser = linkUser.filter(x => userRoles.indexOf(x) >= 0);
      }
    }
  } else {
    linkUser = users.map(x => x.id);
  }
  return linkUser;
});
